import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormGroup, Input, Label } from 'reactstrap';

import { messages } from '../../../_shared/i18n/messages';

const propTypes = {

	/**
	 * The input name.
	 */
	name: PropTypes.string.isRequired,

	/**
	 * The input value.
	 */
	value: PropTypes.bool.isRequired,

	/**
	 * The input label text.
	 */
	label: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element,
		PropTypes.array,
		PropTypes.shape(),
	]).isRequired,

	/**
	 * The input placeholder text.
	 */
	placeholder: PropTypes.string,

	/**
	 * True, if editing the input value.
	 */
	isEditing: PropTypes.bool,

	/**
	 * True, if the input value is invalid.
	 */
	isInvalid: PropTypes.bool,

	/**
	 * True, if the label text should be displayed inline with the input.
	 */
	isLabelInline: PropTypes.bool,

	/**
	 * True, if the input value is disabled.
	 */
	disabled: PropTypes.bool,

	/**
	 * Callback function to handle changes to the input value.
	 */
	onChange: PropTypes.func,

};

const SwitchInput = (props) => {

	const {
		name,
		value,
		label,
		placeholder,
		isLabelInline,
		isEditing,
		isInvalid,
		disabled,
		onChange,
	} = props;

	const intl = useIntl();

	if (!isEditing) {

		return (
			<div className="tc-material-input-display tc-material-input-display-switch">
				{((value === true) || (value === false)) &&
					<FormGroup switch>
						<Input
							name={`option-display-${name}`}
							type="switch"
							role="switch"
							checked={value}
							disabled />
						{' '}
						<Label
							for={`option-display-${name}`}
							check>
							{value === true
								? intl.formatMessage(messages.TC_COMPONENTS_FORM_INPUT_CHECKBOX_DISPLAY_TEXT_TRUE)
								: intl.formatMessage(messages.TC_COMPONENTS_FORM_INPUT_CHECKBOX_DISPLAY_TEXT_FALSE)
							}
						</Label>
					</FormGroup>
				}
				{((value === null || value === undefined)) &&
					<span className="tc-material-input-display-empty-value">
						<FormattedMessage {...messages.TC_COMPONENTS_FORM_INPUT_TEXT_EMPTY_VALUE} />
					</span>
				}
			</div>
		);

	}

	return (
		<FormGroup
			className={`tc-material-input-switch ${isInvalid ? 'tc-material-input-invalid' : ''}`}
			switch>
			<Input
				id={`tc-switch-${name}-input`}
				name={name}
				type="switch"
				role="switch"
				checked={value}
				invalid={isInvalid}
				disabled={disabled}
				onChange={(event) => onChange(event.target.checked)} />
			<Label
				for={`tc-switch-${name}-input`}
				check>
				{isLabelInline ? label : placeholder}
			</Label>
		</FormGroup>
	);

};

SwitchInput.propTypes = propTypes;

export default SwitchInput;
